import UiContext from "@contexts/UiContext";
import { useContext, useEffect, useState } from "react";
import OwButton from "@components/shared/OwButton/OwButton";
import OwTitle from "@components/shared/OwTitle/OwTitle";
import { SocketContext } from "@contexts/SocketContext";
import IUiSocketSetup from "@models/IUiSocketSetup";
import EndpointsEnum from "@models/EndpointsEnum";
import ISquareOnCreateDeviceCodeDTO from "@models/DTO/ISquareOnCreateDeviceCodeDTO";
import ISquareCreateDeviceCodeDTO from "@models/DTO/ISquareCreateDeviceCodeDTO";
import UserContext from "@contexts/UserContext";
import SupplierContext from "@contexts/SupplierContext";
import OwLabel from "@components/shared/OwLabel/OwLabel";

type Props = {};

export const SquareTerminalAddModal = (props: Props) => {
    const userModel = useContext(UserContext)!;
    const supplierModel = useContext(SupplierContext)!;
    const uiContext = useContext(UiContext);
    const socket = useContext(SocketContext)!;

    const [deviceCode, setDeviceCode] = useState<string>("");
    const [isActive, setIsActive] = useState<boolean>(false);

    const closeModal = () => {
        uiContext.setModalComponent(null);
        uiContext.showModal(false);
    }

    const onCreateDeviceCode = (data: ISquareOnCreateDeviceCodeDTO) => {
        console.log(data);

        setDeviceCode(data.deviceCode?.code ?? "");
        setIsActive(false);
    }

    const createDeviceCode = () => {
        const payload: ISquareCreateDeviceCodeDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        }

        socket.emit(EndpointsEnum.SquareCreateDeviceCode, payload);

        setIsActive(true);
    }

    const sockets: IUiSocketSetup[] = [
        {endpoint: EndpointsEnum.SquareOnCreateDeviceCode, fn: onCreateDeviceCode},
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint);
            }
        }

    }, []);

    return <div className={"SquareTerminalAddModal p-2"}>
        <div className={"d-flex justify-content-end"}>
            <OwButton centerIconClass="fas fa-times" fn={closeModal} className="btn-danger"/>
        </div>
        <OwTitle title={"add_terminal"} tag={"h3"} />

        <OwButton leftIconClass="fas fa-plus" className="btn-warning" title={"create_device_code"} fn={createDeviceCode} active={isActive} disableOnActive={true}/>

        {
            deviceCode && (<div className={"mt-4"}>
            <div className={"p-2 bg-secondary rounded d-inline-flex"}>
                <OwLabel title={"device_code"} isBold={true} postText=":" className="me-2"/>
                {
                    deviceCode
                }
            </div>
            
        </div>) }

        {
            deviceCode && (<div className={"mt-4"}>
            <div><OwLabel title="close_modal_after_adding_terminal" isBold={true}/></div>
            <OwButton className="btn-primary" title="done" fn={closeModal}/>
        </div>) }
        
    </div>;
};
